import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SearchBar = () => {
  const [destination, setDestination] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (destination.trim()) {
      navigate(`/packages?search=${destination}`);
    }
  };

  return (
    <div className="search-bar">
      <form className="search-form" onSubmit={handleSearch}>
        <input
          type="text"
          className="search-input"
          placeholder="Where do you want to go?"
          value={destination}
          onChange={(e) => setDestination(e.target.value)}
        />
        <button type="submit" className="search-btn">Search</button>
      </form>
    </div>
  );
};

export default SearchBar;